module.exports = __webpack_public_path__ + "static/media/MB_ProviderPortal_1@2x.3b96bba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/medibank/MB_ProviderPortal_1@2x.png
// module id = 216
// module chunks = 0